import request from '@/utils/request'

/** 移动端：提交将某条派工明细踢回配料的申请 */
export function createDispatchOrderItemKickbackRequest(dispatchOrderItemId, data) {
  return request({
    url: `/api/dispatch-order-items/${dispatchOrderItemId}/kickback-requests`,
    method: 'post',
    data: data || {}
  })
}

/** 桌面：踢回申请列表 status=pending|approved|rejected|all */
export function getDispatchOrderItemKickbackRequests(params) {
  return request({
    url: '/api/dispatch-orders/item-kickback-requests',
    method: 'get',
    params
  })
}

export function approveDispatchOrderItemKickbackRequest(kickbackRequestId, data) {
  return request({
    url: `/api/dispatch-orders/item-kickback-requests/${kickbackRequestId}/approve`,
    method: 'post',
    data: data || {}
  })
}

export function rejectDispatchOrderItemKickbackRequest(kickbackRequestId, data) {
  return request({
    url: `/api/dispatch-orders/item-kickback-requests/${kickbackRequestId}/reject`,
    method: 'post',
    data: data || {}
  })
}
